import React, {Component} from 'react'
import {Input, Grid} from 'react-spreadsheet-grid'
import set from 'lodash.set'
import Select, {components, DropdownIndicatorProps} from 'react-select'
import arrow_up from "../../assets/icons/dark_arrow_up.png"
import arrow_down from "../../assets/icons/dark_arrow_down.png"
import {Typography} from "@material-ui/core"

export class CropDataTable extends Component {

    constructor(props) {
        super(props)
        this.state = {
            columns: [],
        };
    }

    componentDidMount() {
        this.populateData().then(() =>{});
    }

    static renderTable(columns, data) {
        return (
            <div id="crop-table">
                <Grid
                    rowHeight={75}
                    columns={columns}
                    rows={data}
                    focusOnSingleClick={true}
                    getRowKey={row => row.id}
                    isScrollable={false}
                    disabledCellChecker={(row, columnId) => {
                        return columnId === 'crop' ||
                            columnId === 'yield_year'
                    }}
                />
            </div>
        );
    }


    render() {
        return (
            CropDataTable.renderTable(
                this.state.columns,
                this.state.data)
        );
    }

    async populateData() {
        const priceFormat = Intl.NumberFormat('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        const numberFormat = Intl.NumberFormat('ru-RU')
        const crop_list = this.props.crop_list
        const data = this.props.data
        const onCropChange = () => (value) => {
            this.props.setCrop(value.value)
            set(data[0], 'cropId', value.value);
        }
        const cur_year = new Date().getFullYear()

        const year_list = [
            {label: cur_year, value: cur_year},
            {label: cur_year + 1, value: cur_year + 1},
            {label: cur_year + 2, value: cur_year + 2},
            {label: cur_year + 3, value: cur_year + 3},
            {label: cur_year + 4, value: cur_year + 4},
            {label: cur_year + 5, value: cur_year + 5},
        ]

        const onYieldPlanChange = () => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            this.props.setYieldPlan(value)
            set(data[0], 'yield_plan', value);
        }

        const onYieldPriceChange = () => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            this.props.setYieldPrice(value)
            set(data[0], 'yield_price', value);
        }

        const onYieldYearChange = () => (value) => {
            this.props.setYieldYear(value.value)
            set(data[0], 'yield_year', value.value);
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const columns = [
            {
                title: 'Планируемая культура',
                value: (row) => {
                    return (
                        <Select
                            maxMenuHeight='254px'
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '52px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '52px',
                                    width: '100%',
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: '50px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar": {
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb": {
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover": {
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            options={crop_list}
                            key={this.state.fieldChange}
                            placeholder="Выберите культуру"
                            defaultValue={crop_list[crop_list.findIndex((r) => r.value === row.cropId)]}
                            onChange={onCropChange()}
                        />
                    );
                },
                id: 'crop',
                getCellClassName: () => "SpreadsheetGrid__cell_focused"

            }, {
                title: 'Планируемая урожайность, ц/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.yield_plan == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={row.yield_plan ? numberFormat.format(row.yield_plan.toString().replace(',', '.')).replace(',', '.') : 0}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onYieldPlanChange()}
                            />
                        </div>
                    );
                },
                id: 'yield_plan',

            }, {
                title: 'Год урожая',
                value: (row, {focus}) => {
                    return (
                        <Select
                            maxMenuHeight='254px'
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '52px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '52px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: '50px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar": {
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb": {
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover": {
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            options={year_list}
                            placeholder="Выберите год"
                            defaultValue={year_list[year_list.findIndex((r) => r.value === row.yield_year)]}
                            onChange={onYieldYearChange()}
                        />
                    );
                },
                id: 'yield_year',
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Ориентировочная цена урожая, руб/т',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.yield_price == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={row.yield_price ? priceFormat.format(row.yield_price.toString().replace(',', '.')).replace(',', '.') : 0}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onYieldPriceChange()}
                            />
                        </div>
                    );
                },
                id: 'yield_price',
            }
        ];

        this.setState({columns: columns, data: data});
    }

}
